import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import { setDocTitle } from "../../../functions/HelperFuncs";
import { userHasAllRights } from "../../../functions/userRights";
import i18n from "../../../functions/i18next.js";
import { download } from "../../../functions/download";

export default {
  data() {
    return {
      id: this.$options.name,
      mySpace: 0,
      bin: 0,
      files: [],
      doneSearching: false,
      selectedFiles: [],
      selectedFolders: [],
      folderId: this.$route.params.id,
      detailView: this.$route.params.detail,
      folderData: null,
      actionBtns: {},
    };
  },

  created() {
    this.setBin();
    this.setMySpace();

    this.setActionBtns();

    setDocTitle(this.mySpace ? "My space" : "folder", this);

    if (!this.detailView) {
      this.getFiles();
    }

    EventBus.$on(`${this.id}-update`, () => {
      this.getFiles();
    });

    this.addBtnListeners();

    EventBus.$on(`files-holder-update`, (data) => {
      //update selected files and folders
      Object.keys(data).forEach((key) => {
        if (data[key] && this[key]) {
          this[key] = data[key];
        }
      });
    });

    this.setTitle();

    this.setFolderData();
  },
  methods: {
    setFolderData() {
      if (this.bin) {
        //get bin items
      } else {
        this.$axios
          .get(
            `${baseUrl}/folderdetail?folder=${this.$route.params.id}&myspace=${this.mySpace}`,
            {
              responseType: "json",
            }
          )
          .then((r) => {
            this.folderData = r.data;
          });
      }
    },
    setTitle() {
      //set title
      if (this.bin) {
        setDocTitle("bin", this);
        return;
      }

      if (!this.$route.params.file) {
        this.$axios
          .get(
            `${baseUrl}/folderdetail?folder=${this.$route.params.id}&myspace=${this.mySpace}`,
            {
              responseType: "json",
            }
          )
          .then((r) => {
            setDocTitle(r.data.name ? r.data.name : "My space", this);
          });
      } else {
        this.$axios
          .get(
            `${baseUrl}/file?file=${this.$route.params.file}&myspace=${this.mySpace}`,
            {
              responseType: "json",
            }
          )
          .then((r) => {
            setDocTitle(r.data.name, this);
          });
      }
    },
    addBtnListeners() {
      [...this.actionBtns.defaultBtns, ...this.actionBtns.selectedBtns].forEach(
        (btn) => {
          EventBus.$on(btn.emitterName, (data) => {
            if (btn.func) {
              btn.func(data);
            } else {
              this.openRightSidebar(
                btn.emitterName.substring(btn.emitterName.lastIndexOf("-") + 1),
                {
                  folderId: this.folderId,
                  mySpace: this.mySpace,
                }
              );
            }
          });
        }
      );
    },

    downloadSelected(e) {
      download(
        {
          type: "multi",
          items: this.$store.state.transferItems,
          btn: e.event.target,
        },
        this
      );
    },
    restoreSelected() {
      const formData = new FormData();
      const promises = [];

      formData.append(
        "folders",
        [...this.$store.state.transferItems.selectedFolders].map(
          (folder) => folder.id
        )
      );
      formData.append("files", [
        ...this.$store.state.transferItems.selectedFiles.map((file) => file.id),
      ]);

      promises.push(this.$axios.post(baseUrl + "/fileRestore", formData));
      promises.push(this.$axios.post(baseUrl + "/folderRestore", formData));

      Promise.all(promises).then((r) => {
        this.isLoading = false;
        EventBus.$emit("closeallactions");
        //refresh folders
        EventBus.$emit(`desktop-files-update`);
        EventBus.$emit(`tree-overview-reset`);

        // this.$root.$refs.navigation_sidebar.showCollectedBadge();
        this.$store.state.transferItems = {
          selectedFiles: [],
          selectedFolders: [],
          collection: {},
        };
      });
    },

    deleteSelected() {
      this.openRightSidebar("removeFilePermanent", [
        ...this.$store.state.transferItems.selectedFiles,
        ...this.$store.state.transferItems.selectedFolders,
      ]);
    },
    transferSelected() {
      EventBus.$emit(`right-sidebar-show`, {
        id: "transfer",
        data: [
          ...this.$store.state.transferItems.selectedFiles,
          ...this.$store.state.transferItems.selectedFolders,
        ],
      });
    },
    collectSelected() {
      if (this.$store.state.role) {
        //is a logged in user
        this.openRightSidebar("collect");
      } else {
        //is a public user
        //so add to downloadForCollection

        const newCollectForDownload = [...this.$store.state.collectForDownload];
        const selectedFiles = [
          ...this.$store.state.transferItems.selectedFiles,
        ];

        selectedFiles.forEach((file) => {
          if (
            !newCollectForDownload.filter((col) => col.id === file.id).length
          ) {
            //not found in array so push
            newCollectForDownload.push(file);
          }
        });

        localStorage.setItem(
          "collectForDownload",
          JSON.stringify(newCollectForDownload)
        );

        this.$store.state.collectForDownload = newCollectForDownload;
      }
    },
    openFileIfPresent() {
      //get file id
      const fileId = this.$route.params.file;

      if (fileId) {
        this.$axios
          .get(`${baseUrl}/file?file=${fileId}&myspace=${this.mySpace}`, {
            responseType: "json",
          })
          .then((r) => {
            setDocTitle(r.data.name, this);

            EventBus.$emit(`right-sidebar-show`, {
              id: "file",
              data: r.data,
            });
          });
      }
    },
    setMySpace() {
      this.mySpace = this.$route.path.indexOf("myspace") !== -1 ? 1 : 0;
    },
    setBin() {
      this.bin = this.$route.path.indexOf("bin") !== -1 ? 1 : 0;
    },
    setActionBtns() {
      this.actionBtns = {
        defaultBtns: !this.bin
          ? [
              {
                name: i18n.t("files.new_folder"),
                icon: "folder--add",
                emitterName: `${this.$options.name}-newFolder`,
                emitterData: {},
                rights: ["create_folders"],
                useMySpace: true,
                showOnMySpace: true,
              },
              {
                name: i18n.t("common.upload"),
                icon: "upload",
                emitterName: `${this.$options.name}-upload`,
                emitterData: {},
                rights: ["create_files"],
                useMySpace: true,
                showOnMySpace: true,
                disabled: () => {
                  return (
                    this.$store.state.company_full.usage >=
                    this.$store.state.company_full.plan.size
                  );
                },
              },
              {
                name: i18n.t("common.more"),
                icon: "dots",
                emitterName: `${this.$options.name}-more`,
                emitterData: {},
                rights: [
                  "delete_folders",
                  "delete_files",
                  "create_folders",
                  "create_files",
                  "make-private_folders",
                  "copy+paste",
                ],
              },
            ]
          : [
              {
                name: "Empty bin",
                icon: "delete--alt",
                emitterName: `${this.$options.name}-emptyBin`,
                emitterData: {},
                rights: ["delete_folders", "delete_files"],
              },
            ],
        selectedBtns: !this.bin
          ? [
              {
                name: i18n.tc("common.download"),
                icon: "download",
                emitterName: `${this.$options.name}-downloadSelected`,
                emitterData: {},
                rights: ["download_folders", "download_files"],
                useMySpace: true,
                showOnMySpace: true,
                func: (data) => this.downloadSelected(data),
              },
              {
                name: i18n.t("transfer.transfer"),
                icon: "transfer",
                emitterName: `${this.$options.name}-transfer`,
                emitterData: {},
                rights: ["transfer_folders", "transfer_files"],
                func: () => this.transferSelected(),
              },
              {
                name: i18n.t("collection.collect"),
                icon: "collect",
                emitterName: `${this.$options.name}-collect`,
                emitterData: {},
                rights: ["collect"],
                func: () => this.collectSelected(),
              },
              {
                name: i18n.t("common.more"),
                icon: "dots",
                emitterName: `${this.$options.name}-more`,
                emitterData: {},
                rights: [
                  "delete_folders",
                  "delete_files",
                  "create_folders",
                  "create_files",
                  "make-private_folders",
                  "copy+paste",
                ],
              },
            ]
          : [
              {
                name: i18n.t("bin.restore_selected"),
                icon: "folder--add",
                emitterName: `${this.$options.name}-restoreFile`,
                emitterData: {},
                rights: ["delete_folders", "delete_files"],
                func: () => this.restoreSelected(),
              },
              {
                name: i18n.t("bin.permanently_delete"),
                icon: "delete--alt",
                emitterName: `${this.$options.name}-removeFilePermanent`,
                emitterData: {},
                rights: ["delete_folders", "delete_files"],
                func: () => this.deleteSelected(),
              },
            ],
      };
    },
    getFiles() {
      //close all actions
      EventBus.$emit(`closeallactions`);

      this.doneSearching = false;

      if (this.bin) {
        this.$axios.get(baseUrl + `/deleted`).then((r) => {
          this.files = r.data;

          this.doneSearching = true;

          this.openFileIfPresent();
        });
      } else {
        this.folderId = this.$route.params.id;

        this.$axios
          .get(
            baseUrl + `/folder?folder=${this.folderId}&myspace=${this.mySpace}`,
            {
              responseType: "json",
            }
          )
          .then((r) => {
            this.files = r.data;

            this.doneSearching = true;

            this.openFileIfPresent();
          });
      }
    },
    checkUrlForBigChanges(newRoute, lastRoute) {
      return newRoute !== lastRoute;
    },
    openRightSidebar(id, data) {
      EventBus.$emit(`right-sidebar-show`, {
        id: id,
        data,
      });
    },
  },
  computed: {
    canUpload() {
      return userHasAllRights(["create_files"], this);
    },
    doneLoadingEmpty() {
      return this.folderData;
    },
    checkIsSpace() {
      return this.folderData ? this.folderData.parent_id === null : false;
    },
    checkisMySpace() {
      return !this.folderId && this.mySpace === 1;
    },
  },
  watch: {
    $route(newRoute, lastRoute) {
      this.setBin();
      this.setMySpace();
      this.setTitle();

      this.setActionBtns();

      if (
        this.checkUrlForBigChanges(newRoute.path, lastRoute.path) ||
        this.files.length === 0
      ) {
        //big url change so reload the files
        this.getFiles();
      }

      this.detailView = this.$route.params.detail;
    },
  },
};
